// extracted by mini-css-extract-plugin
export default {"cardRoot":"companyActions_cardRoot__Kvi-2","adminBox":"companyActions_adminBox__TwwWS","status":"companyActions_status__p-ozz"};